import omit from 'lodash-es/omit'

import * as styles from './MultiValuedListMoreItem.module.css'

function MultiValuedListMoreItem({
  Component = 'div',
  className = styles.MultiValuedListMoreItem,
  ref,
  ...props
}) {
  const divProps = omit(props, ['activeItem'])

  return <Component {...divProps} className={className} ref={ref} />
}

export default MultiValuedListMoreItem
